// fieldLabel — one required marker, however the call site asks for it.
//
// The form fields draw their own red asterisk from `required`. But the
// convention that predates that — a literal "*" typed into the label text — is
// still on 72 labels across 27 files, and 11 of those pass `required` too, so
// both markers rendered: "Company Name **", "Contact Person **", "Email **" on
// the client form, and the same on the courier, sales-invoice, sales-channel
// and finished-goods forms.
//
// Normalised here rather than at the 11 call sites, because the other 61
// labels depend on the old spelling: strip a trailing star from the text and
// read it as the marker, so exactly one is drawn either way and a label that
// carries a star without `required` keeps the marker it was relying on.
//
// This lives in its own module because there are three label renderers —
// fiori.js Labelled (what the app actually renders), fioriBridge.js AoneInput's
// prefix/suffix branch, and components.js AoneInput/AoneSelect — and a shared
// helper in any one of them would import-cycle through the others.
const TRAILING_STAR = /\s*\*\s*$/;

export function fieldLabel(label, required) {
  const hasStar = typeof label === 'string' && TRAILING_STAR.test(label);
  return {
    text: hasStar ? label.replace(TRAILING_STAR, '') : label,
    showStar: Boolean(required || hasStar),
  };
}
